import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import FlexRow from "../../../components/base/FlexRow";
import ScrollContainer from "../../../components/base/ScrollContainer";
import Section from "../../../components/base/Section";
import Layout from "../../../components/layouts/Layout";
import VoiceSideMenu, { useVoiceSideMenuItems } from "./VoiceSideMenu";
import { clearPageName, getOwner, hasRoles, useScreen } from "../../../core/Global";
import PageTitleBar from "../../../components/layouts/header/PageTitleBar";
import { getFirstAccessibleLink, useModuleLastPage } from "../../../components/layouts/aside/useModuleLastPage";
import ModuleSidebar from "../../../components/layouts/aside/ModuleSidebar";


export default function VoiceMainView() {

    const screen = useScreen()
    const location = useLocation()
    const sideMenuItems = useVoiceSideMenuItems()
    const defaultLink = getFirstAccessibleLink(sideMenuItems, "/voice/calls/history") ?? "/voice/calls/history"
    useModuleLastPage("/voice", defaultLink)

    useEffect(() => {
        return () => {
            clearPageName()
        }
    }, [location.pathname])

    const owner = getOwner()
    const showSidebar = !owner?.freeVoiceAccount && hasRoles(["ExtensionsList", "QueuesList", "ListActiveNumbers", "ListReleasedNumbers", "IsCustomer"])

    return (
        <Layout wide noToolbar paddingBottom={0} paddingTop={0}>
            <Section fluid fit>
                <FlexRow alignItems="start">

                    {
                        showSidebar && !screen.isMobile &&
                        <ModuleSidebar storageKey="rinvox-sidebar-collapsed-voice">
                            <VoiceSideMenu />
                        </ModuleSidebar>
                    }

                    <div className="flex-row-fluid">

                        <PageTitleBar />

                        <ScrollContainer>
                            <Outlet />
                        </ScrollContainer>

                    </div>

                </FlexRow>
            </Section>
        </Layout>
    )
}
